import { apiClient } from '@app/api';
import { useMemo, useState } from 'react';

/**
 * Builds the live HLS playlist URL for a station.
 * Appends a mount-stable `liveSessionId` so the backend can correlate playlist reloads
 * within the same player session.
 */
export function useStationLiveHlsUrl(stationId: string) {
  const [liveSessionId] = useState(() => crypto.randomUUID());

  const src = useMemo(() => {
    if (!stationId) {
      return;
    }

    return apiClient.generateUrl(`/segments/stations/${stationId}/hls-live`, {
      secure: true,
      params: { windowSeconds: 90, liveSessionId },
    });
  }, [stationId, liveSessionId]);

  return src;
}
